import React from 'react'
import MarkdownPage from '../components/MarkdownPage'

export default function About(){
  return <MarkdownPage name="about" />
}
